<template>
  <div class='panel bgPanel h24x-min mt1x pb1x emptyToken_EE'>
    <div class="title title-bg" style="margin-bottom:0">
      <span :title="getLanguageStr('plant406','逆变器排名')">{{getLanguageStr("plant406","逆变器排名")}}</span>
      <!-- <a class="fR fs08x" v-if="stationInfo.gridInterconnectionType=='EXCESS'" @click="$emit('realData')">{{$t('',['点击查看详情'])}}</a> -->
      <div class="tool">
				<div class="icoSys h2x w2x curP" @click="$emit('stepTo','InverterList')">
					<svg class="ico fSub"><use xlink:href="#more"></use></svg>
				</div>
			</div>
    </div>
    <div class="cb table h20x-min">
      <Loading v-if='loadshow' />
      <NoResult v-if='!data||data.length===0' />
      <div scroll="{'axis':'x'}" v-show='data.length>0'>
        <div class="tableSys head noSelect b cField bdLight-bottom" :style="{
              'min-width':
              stage.setting.system.autoColumnWidth[0] * column.length + stage.setting.system.autoColumnWidth[1],
          }" scrollFloatY="false">
          <div class="taL sequence" :title="getLanguageStr('plant467', '逆变器名称')">
            {{ getLanguageStr("plant467", "逆变器名称") }}

          </div>
          <div class="taL sequence" :class='{cMain: this.hourDESC}' @click='sortList("hourDESC")' :title="getLanguageStr('word1882', '当日满发小时') + '(h)'">
            {{ getLanguageStr("word1882", "当日满发小时") + "(h)" }}
            <span :sequence="hourDESC"></span>
          </div>
          <div class="taL sequence" :class='{cMain: this.gyDESC}' @click='sortList("gyDESC")' :title="getLanguageStr('plant_list8', '功率归一化')">
            <span>{{ getLanguageStr("plant_list8", "功率归一化")}}</span>
            <span :sequence="gyDESC"></span>
          </div>
        </div>
        <div class="fixedScrollBar scrollY tra-fast h15x-min" scroll="{'group':'a'}">
          <table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
            <thead class="head-token">
              <tr>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
              <tr v-for="(item, index) in data" :key="index">
                <td @click='openDetail(item)' :title="item.name">{{item.name?item.name:getTypeText(item.type,'deviceType')}}</td>
                <td :title="item.fullPowerHoursDay">{{item.fullPowerHoursDay!==null?item.fullPowerHoursDay:'--'}}</td>
                <td v-if='item.generationCapacity===null'>
                  --
                </td>
                <td v-else>
                  <Progress :percent='item.generationCapacity +"%"' />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class='mt1x cSub pl1x'>{{getLanguageStr('plant197','限10个')}}</div>
  </div>

</template>
<script>
// import ViewDetail from '@/view/device/operationalAudit/ViewDetail.vue'
import * as lib from '@/util/lib.js'
import { getLanguageStr } from '@/util/language'
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading'
import Progress from '@/components/common/Progress.vue'
import {OperationInverter} from '@/api/maintain/plant/list.js'
// import DeviceDetail from '@/view/device/operationalAudit/ViewDetail.vue'
export default {
  // name: 'inverterrank',
  data () {
    return {
      stage,
      floatColumn: new Array(2),
      column: new Array(1),
      data: [],
      hourDESC: 'ASC',
      gyDESC: '',
      loadshow: false,
      isopenState: false,
      requestp: {
        'order.direction': 'ASC',
        'order.property': 'full_power_hours_day'
      }
    }
  },
  props: {
    stationInfo: {
      type: Object,
      default: function () {
        return {x: 1}
      }
    },
    child: {
      type: Boolean,
      default: false
    },
    stationInfoSys: {
      type: [Number, String, Object]
    },
    roleCode: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    stationInfo: {
      deep: true,
      handler: function (v) {
      }
    }
  },
  components: { NoResult, Loading, Progress },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    doPermissions: lib.doPermissions,
    openDetail (item) {
      if (this.isopenState) return
      item.deviceId = item.id
      this.isopenState = true
      this.$bus.$on('opened', this.isopenNow)
      this.$bus.$emit('openViewdetailHead', item, this.$el)
      // this.$dynamic($(this.$el).parents('#app').find('.frame-main section:first')[0], ViewDetail, { bg: true }, {
      //   'closePage': [],
      //   'refresh': [],
      //   'update': [],
      //   'showStations': [],
      //   'DeviceControls': [],
      //   'DeviceUpgrades': [],
      //   'Dels': []
      // }, {}).then(({ instance, childInstance }) => {
      //   // this.sView.push({instance, childInstance})
      //   let dec = 1
      //   if (data.deviceType === 'COLLECTOR') {
      //     dec = 1
      //   } else {
      //     dec = 2
      //   }
      //   childInstance.show(item, indexnow, instance, type, num, boo)
      // })
      // this.$dynamic($(this.$el).parents('#app').find('.frame-main section:first')[0], DeviceDetail, {
      //   bg: true
      // }, {
      //   'closePage': [],
      //   'refresh': [],
      //   'update': [],
      //   'showStations': [],
      //   'DeviceControls': [],
      //   'DeviceUpgrades': [],
      //   'Dels': []
      // }, {}).then(({instance, childInstance}) => {
      //   childInstance.show(item, '', instance)
      // })
    },
    isopenNow () {
      this.isopenState = false
      this.$bus.$off('opened')
    },
    clone (arr) {
      return _.cloneDeep(arr)
    },
    getList () {
      this.requestp.page = 1
      this.requestp.size = 10
      if (this.child) {
        this.requestp.systemId = this.stationInfoSys.systemId
      }
      if (!this.stationInfo.id) return
      let rc
      if (this.roleCode && this.roleCode.length === 0) {
        rc = null
      } else {
        rc = this.roleCode
      }
      // console.log(rc)
      // console.log(!this.doPermissions('A/B/A7', {targetCode: 'A3', codeList: this.clone(rc)}))
      if (this.doPermissions('A/B/A7', {targetCode: 'A3', codeList: this.clone(rc)}) === false || this.doPermissions('A/B/A7', {targetCode: 'A3', codeList: this.clone(rc)}) === 'false') {
        this.data = []
        return
      }
      // console.log(111)
      OperationInverter(this.stationInfo.id, this.requestp).then(data => {
        this.data = data.data
      })
    },
    sortList (name) {
      switch (name) {
        case 'hourDESC':
          this.gyDESC = ''
          this.hourDESC === 'DESC' ? this.hourDESC = 'ASC' : this.hourDESC = 'DESC'
          this.requestp = {
            'order.direction': this.hourDESC,
            'order.property': 'full_power_hours_day'
          }
          break
        case 'gyDESC':
          this.gyDESC === 'DESC' ? this.gyDESC = 'ASC' : this.gyDESC = 'DESC'
          this.hourDESC = ''
          this.requestp = {
            'order.direction': this.gyDESC,
            'order.property': 'generation_capacity'
          }
          break
      }
      this.getList()
    }
  },
  mounted () {
    this.getList()
  }
}
</script>
<style lang="scss" scoped>
$operateMin: 4em + 1;
$operateMax: 4em * 2 + 1;
.operate {
  > * {
    width: $operateMax;
  }
  &[mode] {
    width: $operateMax;
  }
  &[mode="min"] {
    width: $operateMin;
    &:hover {
      transform: translateX($operateMin - $operateMax);
    }
  }
}
.flexBox {
  display: flex;
}
.flexBox-r {
  flex-direction: row;
}
.process {
  width: 10em;
  height: 1em;
  background-color: rgba(0, 0, 0, 0.05);
  overflow: hidden;
  border-radius: 1em;
  margin-right: 1em;
  position: relative;
  .barView {
    background-color: $blueLight;
    height: 1em;
    border-radius: 1em;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/inverterRank.vue